import { Link } from "react-router";
import logo from "@/assets/logo.svg";
import { useCookieConsent } from "../contexts/CookieConsentContext";
import { legalProfile } from "../legal";
import { getCityLandingLabel, getCityLandingPath, seoCityLandingPages } from "../local-pages";

export function Footer() {
  const { hasAnalyticsConfigured, openPreferences } = useCookieConsent();
  const seoLinks = seoCityLandingPages.map((entry) => ({
    href: getCityLandingPath(entry.citySlug, entry.variant),
    label: getCityLandingLabel(entry),
  }));

  return (
    <footer className="bg-[#121212] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img src={logo} alt="mutzur" className="h-4 mb-6 mt-2 brightness-0 invert" />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Professionelle Websites zum Festpreis. <br/>
              Damit Sie bei Ihrem Kerngeschäft bleiben können.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/angebot"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Angebot
                </Link>
              </li>
              <li>
                <Link
                  to="/ablauf"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Ablauf
                </Link>
              </li>
              <li>
                <Link
                  to="/preise"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Preise
                </Link>
              </li>
              <li>
                <Link
                  to="/softwareentwicklung"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Software
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/professionelle-website-ohne-aufwand"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Website ohne Aufwand
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:kontakt@mutzur.de"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  kontakt@mutzur.de
                </a>
              </li>
              <li>
                <a
                  href="tel:+4915129796172"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  +49 151 29796172
                </a>
              </li>
              <li className="text-sm text-gray-400">
                {legalProfile.street}, {legalProfile.postalCode} {legalProfile.city}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} mutzur. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link
              to="/impressum"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Datenschutz
            </Link>
            <Link
              to="/agb"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              AGB
            </Link>
            <Link
              to="/widerruf"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Widerruf
            </Link>
            {hasAnalyticsConfigured ? (
              <button
                type="button"
                onClick={openPreferences}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Cookie-Einstellungen
              </button>
            ) : null}
          </div>
        </div>

        <div className="mt-6 border-t border-gray-900 pt-6">
          <p className="text-[11px] uppercase tracking-[0.18em] text-gray-600">Regionen</p>
          <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2">
            <Link
              to="/standorte"
              className="text-xs text-gray-600 hover:text-gray-400 transition-colors"
            >
              Standorte
            </Link>
            {seoLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-xs text-gray-600 hover:text-gray-400 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
